var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKeyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0642 6.06156L9.93377 3.93837C8.85137 2.85597 7.0962 2.85597 6.013 3.93837L3.689 6.25678C2.6066 7.33838 2.6066 9.10153 3.689 10.1831L5.8186 12.3135C6.901 13.3967 8.65697 13.3967 9.74577 12.3135L10.7458 11.3079L9.85777 12.2176L11.013 13.3719C11.141 13.5007 11.2242 13.6672 11.2498 13.8464L11.3386 14.4719C11.3906 14.8359 11.673 15.1231 12.0346 15.1807L12.813 15.3055C13.0794 15.3487 13.3082 15.5175 13.429 15.7583L14.0778 17.0623C14.2282 17.3647 14.545 17.5463 14.881 17.5247L17.1226 17.3791V16.0055C17.1226 15.2423 16.8178 14.5135 16.2826 13.9727L12.1754 9.86393C13.1402 8.77513 13.1122 7.10956 12.0642 6.06156Z",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M8.22488 6.38907L6.36328 8.25064",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyIcon);
export default __webpack_public_path__ + "static/media/KeyIcon.21bc2ea4e226fa09b2d23377a133063e.svg";
export { ForwardRef as ReactComponent };